import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Photography = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="67" viewBox="0 0 79 67" width="79" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M73.25 16.76v42.87a2.65 2.65 0 0 1-2.65 2.65H9.54a2.65 2.65 0 0 1-2.65-2.65V16.76a2.65 2.65 0 0 1 2.65-2.66h4.83a2.67 2.67 0 0 1-2.65-2.68v-1.1a2.65 2.65 0 0 1 2.65-2.65h16.95a2.65 2.65 0 0 1 2.65 2.66v1.09a2.7 2.7 0 0 1-2.65 2.68h39.29a2.65 2.65 0 0 1 2.65 2.66Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M68.39 12.85V27.6H4.89V12.85c0-1.4 1.14-2.53 2.54-2.53h58.42c1.4 0 2.54 1.13 2.54 2.53Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M68.39 27.6v26.28c0 1.4-1.14 2.53-2.54 2.53H7.43a2.54 2.54 0 0 1-2.54-2.53V27.6z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M29.95 4.16H10.38a.86.86 0 0 0-.86.86v4.43c0 .47.38.86.86.86h19.57c.47 0 .85-.39.85-.86V5.02a.86.86 0 0 0-.85-.86Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M36.65 51.39a17.76 17.76 0 1 0 0-35.52 17.76 17.76 0 0 0 0 35.52Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path d="M45.87 27.49v12.3h-6.15v-6.16h-6.14v6.15h-6.15V27.5z" fill={shades.black} />
    </svg>
  );
};
